import { api } from '@api'

interface DownloadExcelResponse {
  sapTptImportHistoryUrl: string
}

type Params = {
  id: number
}

const downloadExcelFile = async (params: Params) => {
  const { id } = params
  const response = await api.get<DownloadExcelResponse>('/log-sap-tpt-import/download', {
    params: {
      id,
    },
  })
  return response.data
}

export const DownloadExcelApi = { downloadExcelFile }
